module.exports = __webpack_public_path__ + "static/media/edit-border-blue.a5c788a8.svg";